// src/components/Hero.jsx
import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import LocationMap from './LocationMap';

const Hero = () => {
  const [showLocations, setShowLocations] = useState(false);

  return (
    <>
      <div id="hero-container" className="container-fluid">
        <div className="container">
          <div>
            <div>
              <h1>Hope. Healing. Innovation.</h1>
              <p>You deserve relief. Let's take the first step together.</p>
              <div style={{ display: 'flex', gap: '15px' }}>
                <a href="/newpatients" className="button blue">
                  Schedule an Appointment
                </a>
                <button 
                  className="button blue" 
                  onClick={() => setShowLocations(true)}
                >
                  View Locations
                </button>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center'}}>
              <LazyLoadImage alt="Hero" effect="blur" src="/img/hero-image.png" style={{ borderTopLeftRadius: '0px', borderTopRightRadius: '0px', borderBottomLeftRadius: '0px', borderBottomRightRadius: '0px' }} />
            </div>
          </div>
        </div>
      </div>

      {/* Locations Modal */}
      {showLocations && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => setShowLocations(false)}>
          <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content" style={{ borderRadius: '20px', border: 'none' }}>
              <div
                className="modal-header text-white"
                style={{
                  background: '#3a66bd',
                  borderTopLeftRadius: '20px',
                  borderTopRightRadius: '20px',
                }}
              >
                <h5 className="modal-title text-center w-100" style={{ fontWeight: 600 }}>
                  Our Locations
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowLocations(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body bg-light">
                <div className="container">
                  <LocationMap />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Hero;